import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { InvestigationStatusResponse } from '@cureskin/api-client/src/server-api/api';

export interface InvestigationSheetData {
  investigationStatus: InvestigationStatusResponse;
  doctorImage: string;
}

export interface NormalizedTest {
  name: string;
  required: boolean;
}

@Component({
  selector: 'investigation-sheet',
  templateUrl: './investigation-sheet.html',
})
export class InvestigationSheetComponent {
  // eslint-disable-next-line new-cap
  readonly data: InvestigationSheetData = inject(MAT_BOTTOM_SHEET_DATA);
  private readonly bottomSheetRef = inject(MatBottomSheetRef);
  private readonly router = inject(Router);

  get normalizedTests(): NormalizedTest[] {
    return (this.data.investigationStatus.investigation?.tests ?? []).map(
      (t) => typeof t === 'string' ? { name: t, required: true } : { name: t.test, required: t.required },
    );
  }

  closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
  }

  onUploadReport(): void {
    this.bottomSheetRef.dismiss();
    this.router.navigate(['/user/instantCheckup']);
  }
}
